export default __webpack_public_path__ + "static/florian-ehmes-266x266-97b493c5ad5dcae19ced3565bd4001e1.png";